export const AUTOMATION_TRIGGERS = [
    { id: "task_overdue", label: "Task is overdue" },
    { id: "paused_too_long", label: "Paused too long" },
    { id: "unassigned_too_long", label: "Unassigned too long" },
    { id: "task_created", label: "Task is created" },
    { id: "task_completed", label: "Task is completed" },
];

export const AUTOMATION_ACTIONS = [
    { id: "notify_manager", label: "Notify manager" },
    { id: "notify_assignee", label: "Notify assignee" },
    { id: "escalate", label: "Escalate (high + notify manager)" },
    { id: "comment", label: "Add a comment" },
    { id: "assign_to", label: "Assign to someone" },
    { id: "set_priority", label: "Set priority" },
    { id: "spawn_template", label: "Create from template" },
];

export const AUTOMATION_PRESETS = [
    {
        preset: "overdue_high_notify_manager",
        name: "Overdue high → notify manager",
        hint: "Once a day while a high-priority task stays overdue.",
    },
    {
        preset: "paused_2h_escalate",
        name: "Paused 2 hours → escalate",
        hint: "Marks it high, comments, and notifies you.",
    },
    {
        preset: "unassigned_1h_notify_manager",
        name: "Unassigned 1 hour → notify manager",
        hint: "Inbox work that nobody picked up.",
    },
];

export function triggerLabel(id) {
    return AUTOMATION_TRIGGERS.find((row) => row.id === id)?.label || id;
}

export function actionLabel(id) {
    return AUTOMATION_ACTIONS.find((row) => row.id === id)?.label || id;
}

export const EMPTY_AUTOMATION = {
    name: "",
    trigger: "task_overdue",
    action: "notify_manager",
    minutes: 60,
    priority: "",
    comment: "",
    assign_to: "",
    set_priority: "high",
    template_id: "",
};

export function draftToPayload(draft) {
    const trigger_config = {};
    if (draft.trigger === "paused_too_long" || draft.trigger === "unassigned_too_long") {
        trigger_config.minutes = Number(draft.minutes) || 60;
    }
    if (draft.priority) trigger_config.priority = draft.priority;

    const action_config = {};
    if (draft.action === "comment" || draft.action === "escalate") {
        action_config.comment = draft.comment || "";
    }
    if (draft.action === "assign_to") action_config.assign_to = draft.assign_to;
    if (draft.action === "set_priority") action_config.priority = draft.set_priority || "high";
    if (draft.action === "spawn_template") {
        action_config.template_id = draft.template_id;
        if (draft.assign_to) action_config.assign_to = draft.assign_to;
    }

    return {
        name: String(draft.name || "").trim(),
        trigger: draft.trigger,
        trigger_config,
        action: draft.action,
        action_config,
        enabled: true,
    };
}
